// eslint-disable-next-line import/no-anonymous-default-export
export default ({ request }) => ({
    getBookList(params) {
        return request({
            url: 'admin/book/list',
            method: 'get',
            params,
        });
    },
    BookDel(params) {
        return request({
            url: 'admin/book/del',
            method: 'get',
            params,
        });
    },
    BookAdd(data) {
        return request({
            url: 'admin/book/add',
            method: 'post',
            data,
        });
    },
});
